import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Muhammad Hamza',
    title: "MERN Stack Developer",
    desciption:"Experience is every thing to me, I saw there’s no small and moderate learning , learning is always helps you when you get stuck no matter either its small or its too big matter is its always helps you in most needed places.",
    image: 'https://avatars.githubusercontent.com/u/26695351?s=400&u=1ede922fe8349ea830e85918319867a5ce265f48&v=4',
    resumePdf: resume
}
